import React from 'react'
import { createContext } from 'lib/createContext'
import { Loading, Text } from '@workwhile/ui'
import { useShiftByIdQuery } from 'queries/shifts/useShiftByIdQuery'
import { ShiftDetail } from 'pages/Shifts/ShiftDetail/types'
import { DayforceShiftAssociationType } from 'pages/Dayforce/constants'
import { useBookingDetailsContextValue } from '../../../context/BookingDetailsProvider'

type BookingShiftDetailProviderProps = {
  children: React.ReactNode
  shiftId: number
  shiftIdx: number
}

type BookingShiftDetailContextValue = {
  state: {
    shiftIdx: number
    workWhileShift: ShiftDetail
    associationType: DayforceShiftAssociationType
    isLoadingWorkWhileShift: boolean
  }
}

const [Context, useBookingShiftDetailContextValue] =
  createContext<BookingShiftDetailContextValue>({
    name: 'BookingShiftDetailContext',
  })

export const BookingShiftDetailProvider = ({
  children,
  shiftId,
  shiftIdx,
}: BookingShiftDetailProviderProps) => {
  const {
    state: { dayforceBooking },
  } = useBookingDetailsContextValue()

  const { data: shift, isLoading: isLoadingWorkWhileShift } =
    useShiftByIdQuery(shiftId)

  if (isLoadingWorkWhileShift) {
    return <Loading />
  }

  if (!shift) {
    return <Text>Shift {shiftId} not found</Text>
  }

  const dayforceShift = dayforceBooking.shifts.find(
    (shift) => shift.id === shiftId
  )

  if (!dayforceShift) {
    return <Text>Dayforce shift {shiftId} not found</Text>
  }

  const value: BookingShiftDetailContextValue = {
    state: {
      shiftIdx,
      workWhileShift: shift,
      associationType: dayforceShift.associationType,
      isLoadingWorkWhileShift,
    },
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useBookingShiftDetailContextValue }
